import React from 'react';
import {
  Users,
  BookOpen,
  FileText,
  Award,
  Trophy,
  Database,
} from 'lucide-react';

export const DATA_SOURCE_ICONS: Record<string, React.ReactNode> = {
  users: React.createElement(Users, { size: 18 }),
  courses: React.createElement(BookOpen, { size: 18 }),
  enrollments: React.createElement(FileText, { size: 18 }),
  certificates: React.createElement(Award, { size: 18 }),
  leaderboard: React.createElement(Trophy, { size: 18 }),
};

export const DEFAULT_DATA_SOURCE_ICON = React.createElement(Database, { size: 18 });

export const CHART_COLORS = [
  '#f97316', '#3b82f6', '#10b981', '#a855f7', '#ef4444',
  '#f59e0b', '#06b6d4', '#ec4899', '#8b5cf6', '#14b8a6',
  '#f43f5e', '#6366f1', '#22c55e', '#eab308', '#0ea5e9',
] as const;

export const AI_EXAMPLE_PROMPTS = [
  'Show me all users grouped by department with their status',
  'List all courses with enrollment counts by category',
  'Show top performers by points and certificates earned',
  'Report on certificate distribution across all students',
  'Show enrollment progress grouped by course category',
] as const;

export type ActiveView = 'table' | 'charts' | 'insights';
export type ChartType = 'bar' | 'pie' | 'horizontal';
export type AggregateFunction = 'count' | 'sum' | 'avg' | 'min' | 'max';
export type SortOrder = 'asc' | 'desc';
export type ExportFormat = 'pdf' | 'excel' | 'csv';
